import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import ButtonIcon from "../../../../button";
import { manageUserHistoryActions } from '../../../../../store/external/manage-user/manage-user-history.reducer';
import { MODAL_CUSTOM_MESSAGE } from '../../../../../constants/external-constants';

class ManageUserHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }

    componentDidMount() {
        this.props.getManageUserHistoryLogs(this.props.employeeId);
    }

    componentWillUnmount() {
        this.props.resetmanageUserHistory();
    }

    getTableData(pageIndex) {
        this.props.getManageUserHistoryLogs(this.props.employeeId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeManageUserHistoryLogs, getManageUserHistoryLogs, employeeId } = this.props;
        resizeManageUserHistoryLogs(pageSize)
        getManageUserHistoryLogs(employeeId);
    }

    manageUserPaginationAction = (pageIndex) => {
        const { getManageUserHistoryLogs, employeeId } = this.props;
        getManageUserHistoryLogs(employeeId, pageIndex);
    }

    onColumnSearch = () => {
        const { getManageUserHistoryLogs, employeeId } = this.props;
        getManageUserHistoryLogs(employeeId, 0);
    }
    

    render() { 

        const { setManageUserHistoryColSearchStr } = this.props;
        const { IsLoadingTable } = this.props.manageUserHistory;
        const { Headers, Data, Pagination } = this.props.manageUserHistory.HistoryTable;

        return (
            <>

                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}
                    pages={Pagination}
                    paginationAction={this.manageUserPaginationAction}
                    onColumnSearch={this.onColumnSearch}
                    onColumnSearchChange={setManageUserHistoryColSearchStr}
                    isColSearchShow={this.props.isColSearchShow}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isNotSortable={true}
                    isLoading={IsLoadingTable}
                    hideStatusIcon={true}
                />
            </>
        );
    }
}


export default connect(
    state => {
        const { manageUserHistory } = state;
        return {
            manageUserHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, manageUserHistoryActions),
        dispatch
    )
)(ManageUserHistory);